// vim: ft=javascriptreact
import { useContext, useState, useEffect } from 'react'
import { ImperialBookingContext } from '../context/ImperialBookingContext'
import {
  Container,
  Row,
  Col,
  Spinner,
  Tabs,
  Tab,
} from 'react-bootstrap'
import { useNavigate, useLocation } from 'react-router-dom'
import SignInForm from './SignInForm'
import SignUpForm from './SignUpForm'
import SignUpFormFacebook from './SignUpFormFacebook'
import SignUpConfirmForm from './SignUpConfirmForm'
import './LandingPage.scss'

const LandingPage = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const {
    authCheckComplete,
    setAuthError,
    user,
    showFacebook,
  } = useContext(ImperialBookingContext)
  const [signUpConfirm, setSignUpConfirm] = useState(/auth\/sign-up-confirm/.test(location.pathname))
  const [activeKey, setActiveKey] = useState(/auth\/sign-up/.test(location.pathname) ? 'sign-up' : 'sign-in')

  const onTabSelect = (activeKey) => {
    setActiveKey(activeKey)
    navigate(`/auth/${activeKey}`)
  }

  useEffect(() => {
    const isSignUpConfirm = /auth\/sign-up-confirm/.test(location.pathname)
    setSignUpConfirm(isSignUpConfirm)
    if (isSignUpConfirm) {
      setActiveKey('sign-up');
    }
  }, [location.pathname])

  if (user) {
    return null
  }

  return (
    <div className="home-banner">
      <Container fluid="md" className="h-100">
        <Row className="h-100 align-items-start">
          <Col className="mt-5 pt-5">
            <h1 className="h1 mt-4 text-center">Amenities Room Booking System</h1>
            {!authCheckComplete && (
              <div className="d-grid justify-content-center">
                <Spinner animation="border" role="status" variant="light">
                  <span className="visually-hidden">Initializing...</span>
                </Spinner>
              </div>
            )}
            {authCheckComplete && (
              <Tabs id="landing" onSelect={onTabSelect} activeKey={activeKey}>
                <Tab eventKey="sign-in" title="Sign In" className="p-4 p-sm-5" tabClassName="me-1">
                  <p className="lead text-left">
                    If you have already signed up, you can sign in below.
                  </p>
                  <SignInForm />
                </Tab>

                <Tab eventKey="sign-up" title="Sign Up" className="p-4 p-sm-5" tabClassName="me-1">
                  <p className="lead text-left">
                    Please sign up here if you are a resident of The Imperial and would like to book the amenities room. All fields are required.
                  </p>
                  {!signUpConfirm && <SignUpForm />}
                  {signUpConfirm && <SignUpConfirmForm />}
                </Tab>

                {showFacebook && (
                  <Tab eventKey="sign-up-facebook" title="Sign Up With Facebook" className="p-4 p-sm-5">
                    <p className="lead text-left">
                      Please sign up here if you are a resident of The Imperial and would like to book the amenities room. You will need a Facebook account.
                    </p>
                    <SignUpFormFacebook />
                  </Tab>
                )}
              </Tabs>
            )}
          </Col>
        </Row>
      </Container>
      <div className="credits">
        Photo by <a href="https://unsplash.com/@alena_horoshaya">Alena Plotnikova</a> on <a href="https://unsplash.com/photos/mAHzkCjWc20">Unsplash</a>.
      </div>
    </div>
  )
}

export default LandingPage
